import style from "./BrandsSlide.module.css";
import { SwiperSlide, Swiper } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useAppSelector } from "../../../store/hooks";
import { configBrandsType } from "../../../types/brands";
import Placeholder from "../../../components/placeHolder/PlaceHolder";
import { placeHolder } from "../../../types/common";

const BrandsSlide = () => {
  const { data, loading } = useAppSelector((state) => state.brands.brands);

  const sliders = data?.data.components?.find((item) => {
    const config = JSON.parse(item.config!) as configBrandsType;
    return config.type === "slider";
  });
  return (
    <div className={style.brands}>
      {!loading ? (
        <div className={style.inner}>
          <Swiper
            className={style.items}
            modules={[Pagination, Autoplay]}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: {
                slidesPerView: "auto",
                spaceBetween: 8,
              },
              1200: {
                slidesPerView: "auto",

                spaceBetween: 8,
              },
            }}
            pagination={{
              type: "bullets",
              clickable: true,
            }}
          >
            {sliders?.attributes?.src_sets.value?.map((item, index) => (
              <SwiperSlide className={style.item} key={index}>
                <img src={`${item.image}`} alt="brands" />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={style.title}>
            <span>برندهای پیشنهادی</span>
          </div>
        </div>
      ) : (
        <Placeholder
          type={placeHolder.IMAGE}
          number={1}
          className="!w-80 lg:!w-96"
        />
      )}
    </div>
  );
};

export default BrandsSlide;
